import { z } from 'zod';

export const ReadEvidenceToolName = 'readEvidence';
export const RecordAnswerSourcesToolName = 'recordAnswerSources';
export const readEvidenceArgsSchema = z.object({
  includeText: z
    .boolean()
    .default(true)
    .describe(
      'False returns only source metadata; true reopens missing passage text. No call is needed when the supporting evidence and IDs are already in context.',
    ),
  sourceIds: z
    .array(z.string().min(1).max(100))
    .max(5)
    .default([])
    .describe(
      'Source IDs to reopen. An empty array lists recent available evidence IDs.',
    ),
});
export const recordAnswerSourcesArgsSchema = z.object({
  sourceIds: z
    .array(z.string().min(1).max(100))
    .max(20)
    .describe(
      'Only evidence IDs supporting this spoken answer; empty explicitly means no retrieved evidence used.',
    ),
});
